/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_VariationsInputs */

const en_reference_field_variations = /** @type {(inputs: Reference_Field_VariationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variations`)
};

/**
* | output |
* | --- |
* | "Variations" |
*
* @param {Reference_Field_VariationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_variations = /** @type {((inputs?: Reference_Field_VariationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_VariationsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_variations(inputs)
});